import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { getApiAccessToken, MsalNotInitializedError } from '../auth/accessToken.ts';
import { createCorrelationId } from '../lib/correlation.ts';

/**
 * fetch() wrapper that attaches the Entra External ID access token for backend calls.
 */
export async function creatorFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  if (!headers.get('X-Correlation-Id')) {
    headers.set('X-Correlation-Id', createCorrelationId());
  }

  // Keep existing header if caller set it explicitly.
  const existingAuth = headers.get('Authorization');
  if (!existingAuth) {
    try {
      const token = await getApiAccessToken();
      headers.set('Authorization', `Bearer ${token}`);
    } catch (e) {
      // If interaction is required, proceed without header so backend returns 401 and UI can react.
      if (!(e instanceof InteractionRequiredAuthError) && !(e instanceof MsalNotInitializedError)) throw e;
    }
  }

  return fetch(input, { ...init, headers });
}

